import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { SessionProvider, useSession } from "./store/session";
import { ToastHost } from "./components/Toast";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import PartsPage from "./pages/PartsPage";
import PartDetailPage from "./pages/PartDetailPage";
import InspectionsPage from "./pages/InspectionsPage";
import InspectionDetailPage from "./pages/InspectionDetailPage";
import OperatorsPage from "./pages/OperatorsPage";
import MetricsPage from "./pages/MetricsPage";
import SettingsPage from "./pages/SettingsPage";
import RegisterPage from "./pages/RegisterPage";

function RequireAuth({ children }: { children: React.ReactElement }) {
  const { session } = useSession();
  return session ? children : <Navigate to="/login" replace />;
}

function AdminOnly({ children }: { children: React.ReactElement }) {
  const { session } = useSession();
  return session?.operator.role === "admin" ? children : <Navigate to="/registrar" replace />;
}

function Home() {
  const { session } = useSession();
  return <Navigate to={session?.operator.role === "admin" ? "/piezas" : "/registrar"} replace />;
}

export default function App() {
  return (
    <SessionProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<RequireAuth><Layout /></RequireAuth>}>
            <Route path="/" element={<Home />} />
            <Route path="/piezas" element={<AdminOnly><PartsPage /></AdminOnly>} />
            <Route path="/piezas/:id" element={<AdminOnly><PartDetailPage /></AdminOnly>} />
            <Route path="/inspecciones" element={<InspectionsPage />} />
            <Route path="/inspecciones/:id" element={<InspectionDetailPage />} />
            <Route path="/operarios" element={<AdminOnly><OperatorsPage /></AdminOnly>} />
            <Route path="/indicadores" element={<AdminOnly><MetricsPage /></AdminOnly>} />
            <Route path="/ajustes" element={<AdminOnly><SettingsPage /></AdminOnly>} />
            <Route path="/registrar" element={<RegisterPage />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <ToastHost />
    </SessionProvider>
  );
}
